import { createAction, props } from '@ngrx/store';
import { IFile, IFolder, IDrive, IUploadedFile, IUploadPreview, IEditFile } from '@app-root-interfaces';
import { IUploadFileForm } from '../../interfaces/upload-file-form.interface';

// File System Navigation Actions
export const removeFromPath = createAction('[Document] Remove from path', props<{ elements: number }>());
export const removeFromPathSuccess = createAction('[Document] Remove from path succes', props<{ path: string[] }>());
export const addToPath = createAction('[Document] Add to path', props<{ folder: IFolder }>());
export const addToPathSuccess = createAction('[Document] Add to path success', props<{ path: string[] }>());
export const setPathBack = createAction('[Document] Set path back');
export const setPathBackSuccess = createAction('[Document] Set path back success', props<{ path: string[] }>());
export const getFavourites = createAction('[Document] Get favourites');
export const getFavouritesSuccess = createAction('[Document] Get favourites success', props<{ favourites: IFile[] }>());
export const getRecentlySeen = createAction('[Document] Get recently seen');
export const getRecentlySeenSuccess = createAction(
    '[Document] Get recently seen success',
    props<{ recentlySeen: IFile[] }>()
);

export const getBasicSuccess = createAction('[Document] Get basic success', props<{ folder: IFolder }>());
export const getDrive = createAction('[Document] Get drive');
export const getDriveSuccess = createAction('[Document] Get drive success', props<{ drive: IDrive }>());
export const setDriveCollectionIds = createAction(
    '[Document] Set Drive Collection Ids',
    props<{ collectionIds: string[] }>()
);

export const getAllDrivesSuccess = createAction('[Document] Get all drives success', props<{ drives: IDrive[] }>());
export const getFolder = createAction('[Document] Get folder', props<{ key: string }>());
export const getFolderSuccess = createAction('[Document] Get folder success', props<{ folder: IFolder }>());
export const buildPathToNode = createAction('[Document] Build path to node', props<{ nodeId: string }>());

export const buildPathToNodeSuccess = createAction(
    '[Document] Build path to node success',
    props<{ path: string[] }>()
);

// Search Actions
export const searchFiles = createAction('[Document] Search files', props<{ keyword: string }>());
export const searchFilesSuccess = createAction('[Document] Search files success', props<{ files: IFile[] }>());
export const searchFilesFailure = createAction('[Document] Search files failure');

// Folder Actions
export const createFolder = createAction('[Document] Create Folder', props<{ name: string }>());
export const createFolderSuccess = createAction('[Document] Create Folder success', props<{ folder: IFolder }>());
export const deleteFolder = createAction('[Document] Delete folder', props<{ folder: IFolder }>());
export const deleteFolderSuccess = createAction('[Document] Delete folder success', props<{ folder: IFolder }>());
export const deleteFolderFailure = createAction('[Document] Delete folder failure', props<{ folder: IFolder }>());
export const patchFolder = createAction('[Document] Patch folder', props<{ folder: IFolder }>());
export const patchFolderSuccess = createAction('[Document] Patch folder success', props<{ folder: IFolder }>());
export const patchFolderFailure = createAction('[Document] Patch folder failure', props<{ folder: IFolder }>());

// File Actions
export const getFile = createAction('[Document] Get file', props<{ id: string }>());
export const getFileSuccess = createAction('[Document] Get file success', props<{ file: IFile }>());
export const addFileToFolders = createAction('[Document] Add file to folders', props<{ file: IUploadedFile }>());
export const deleteFile = createAction('[Document] Delete file', props<{ file: IFile }>());
export const deleteFileSuccess = createAction('[Document] Delete file success', props<{ file: IFile }>());
export const deleteFileFailure = createAction('[Document] Delete file failure', props<{ file: IFile }>());
export const startEditFile = createAction('[Document] Start edit file', props<{ file: IFile }>());
export const cancelEditFile = createAction('[Document] Cancel edit file');
export const updateFile = createAction('[Document] Update file');
export const updateFileSuccess = createAction('[Document] Update file success', props<{ file: IFile }>());
export const updateFileFailure = createAction('[Document] Update file failure');
export const changeFile = createAction('[Document] Change file', props<{ payload: IUploadFileForm }>());
export const changeFileSuccess = createAction('[Document] Change file success', props<{ file: IFile }>());
export const updatePreview = createAction(
    '[Document] Update preview',
    props<{
        preview: IUploadPreview;
    }>()
);

export const editFile = createAction(
    '[Document] Edit file',
    props<{
        file: IUploadPreview;
    }>()
);
export const updateEditFile = createAction('[Document] Update edit file', props<{ file: IEditFile }>());
export const updateEditFileSuccess = createAction('[Document] Update edit file success');
export const updateEditFileFailure = createAction('[Document] Update edit file failure');
export const updateEditPreview = createAction('[Document] Update edit preview', props<{ file: IEditFile }>());
export const updateEditPreviewSuccess = createAction('[Document] Update edit preview success');
export const updateEditPreviewFailure = createAction('[Document] Update edit preview failure');
export const deleteFileFromFolder = createAction('[Document] Delete file from folder', props<{ file: IFile }>());
export const deleteFileFromFolderSuccess = createAction(
    '[Document] Delete file from folder success',
    props<{ file: IFile; folder: IFolder }>()
);

// Drive Actions
export const selectDrive = createAction('[Document] Select drive', props<{ driveId: string }>());
